import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "@zillow/constellation";
const CalculatorLayout = ({
  fields,
  content,
  className,
  sxOverride
}) => {
  return /* @__PURE__ */ jsxs(Box, { className, sx: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "$spacing.md",
    "@media $lg": {
      flexDirection: "row"
    },
    ...sxOverride
  }, children: [
    /* @__PURE__ */ jsx(Box, { sx: {
      width: "100%",
      "@media $lg": {
        position: "sticky",
        top: "0",
        alignSelf: "flex-start",
        order: 2
      }
    }, children: content }),
    /* @__PURE__ */ jsx(Box, { sx: {
      width: "100%",
      "@media $lg": {
        minWidth: "240px",
        maxWidth: "300px",
        order: 1
      }
    }, children: fields })
  ] });
};
export {
  CalculatorLayout as default
};
